import React from 'react'
import { StarChartCloneContainerProps } from '../../types/types'
import StarChartOrgClonePresentation from '../../presentation/starChartOrg.assign.organization.presentation/StarChartOrgClonePresentation'

const StarChartOrgCloneContainer: React.FC<StarChartCloneContainerProps> = ({starChartClone , clonePopup}) => {

  return (
    <StarChartOrgClonePresentation starChartClone={starChartClone} clonePopup={clonePopup}/>

  )
}

export default StarChartOrgCloneContainer

